import { BitbucketIcon } from '@/components/bitbucket/BitbucketIcon';
import { Github } from 'lucide-react';
import type { SourceControlProvider } from './SourceControlIntegrationCard';

export const GithubProvider: SourceControlProvider = {
  id: 'github',
  name: 'github',
  displayName: 'GitHub',
  icon: Github,
  description:
    'Connect your GitHub workspace to invite your organization members to Kirin',
  color: '#000000',
};

export const BitbucketProvider: SourceControlProvider = {
  id: 'bitbucket',
  name: 'bitbucket',
  displayName: 'Bitbucket',
  icon: BitbucketIcon,
  description:
    'Connect your Bitbucket workspace to invite your organization members to Kirin',
  color: '#0052CC',
};

export const ALL_PROVIDERS = [GithubProvider, BitbucketProvider];
